var rtlStyles = {"rtl":"_2J4V5","ltr":"iPC6I"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-1b0960bd.js.map
